import { Grid, Image, Paragraph } from "capitalrx-components-2.0";

import styles from "./WithTheApp.module.scss";

import Access from "@/static/images/image-pink-bubble.jpg";
import Find from "@/static/images/image-green-bubble.jpg";
import Save from "@/static/images/image-blue-bubble.jpg";

const WithTheApp = (): JSX.Element => {
  return (
    <div className={styles.WithAppWrapper} data-testid="with-app-section">
      <section className={styles.WithApp}>
        <Paragraph className={styles.sectionTitle} testId="with-app-section-title">
          Saving on your medications has never been more simple
        </Paragraph>

        <Grid container justifyContent="center" className={styles.WithAppSteps}>
          <Grid item colLg={4} colSm={6} className={styles.WithAppStepsOne}>
            <Image src={Access} alt="Access your card" ariaHidden="true" testId="access-your-card-image" />

            <Paragraph className={styles.heading} testId="with-app-point-1">
              1.
            </Paragraph>
            <Paragraph className={styles.heading} testId="with-app-point-1-heading">
              Find the best price
            </Paragraph>
            <Paragraph className={styles.paragraph} testId="with-app-point-1-text">
              at a pharmacy near you.
            </Paragraph>
          </Grid>
          <Grid item colLg={4} colSm={6} className={styles.WithAppStepsTwo}>
            <Image src={Find} alt="Find the best price" ariaHidden="true" testId="find-best-price-image" />

            <Paragraph className={styles.heading} testId="with-app-point-2">
              2.
            </Paragraph>
            <Paragraph className={styles.heading} testId="with-app-point-2-heading">
              Present your card
            </Paragraph>
            <Paragraph className={styles.paragraph} testId="with-app-point-2-text">
              at the pharmacy.
            </Paragraph>
          </Grid>
          <Grid item colLg={4} colSm={6} className={styles.WithAppStepsThree}>
            <Image src={Save} alt="Start saving" ariaHidden="true" testId="start-saving-image" />

            <Paragraph className={styles.heading} testId="with-app-point-3">
              3.
            </Paragraph>
            <Paragraph className={styles.heading} testId="with-app-point-3-heading">
              Start saving
            </Paragraph>
            <Paragraph className={styles.paragraph} testId="with-app-point-3-text">
              on your prescriptions.
            </Paragraph>
          </Grid>
        </Grid>
      </section>
    </div>
  );
};

export default WithTheApp;
